import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  IconSize,
} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {CARD_ANIMATION_TIME} from '../../CouponCard/components/constants';

export const CouponAppOnlyBadge: FC<{
  'data-testid'?: string;
  className?: string;
  iconSize?: keyof typeof IconSize;
}> = ({'data-testid': dataTestId, className, iconSize = 'XS'}) => {
  const {t} = useTranslation();

  return (
    <AppOnlyBadge
      className={className}
      data-testid={`${dataTestId}AppOnlyBadge`}
    >
      <AppOnlyIcon asset={GenericIconName.AppOnlyIcon} size={iconSize} />
      {t('App only')}
    </AppOnlyBadge>
  );
};

export const AppOnlyIcon = styled(Icon)``;

export const FloatingBadgesCSS = css`
  display: flex;
  align-items: center;
  padding: 4px 6px;
  border-radius: 26px;
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: 1.16;
`;

export const FloatingBadge = styled.div<{$isHotDeal?: boolean}>`
  ${FloatingBadgesCSS}
  color: ${COLORS.PrimaryCoupon};
  background-color: ${COLORS.White};
  padding: 4px 10px 4px 4px;
  position: relative;
  background-clip: padding-box;
  border: 1px solid transparent;

  ${({$isHotDeal}) =>
    !$isHotDeal &&
    css`
      ::before {
        content: '';
        position: absolute;
        inset: 0;
        z-index: -1;
        margin: -1px;
        border-radius: inherit;
        background: ${COLORS.BorderColorCoupon};
        transition: background ${CARD_ANIMATION_TIME}ms ease-in;
      }
    `}
`;

const AppOnlyBadge = styled(FloatingBadge)`
  background-color: ${COLORS.BackgroundCoupon};
  padding: 4px 8px 4px 6px;
  margin-left: 4px;
  text-align: center;
`;
